class QuickAddToCart extends CustomHTMLElement {
    connectedCallback() {
        this.initElements();
        this.attachClickListeners();

        // Listen for the custom event when product info is updated
        this.addEventListener('productInfoUpdated', (event) => {
            this.initElements(); // Reinitialize elements after DOM update
            this.attachClickListeners(); // Reattach listeners
        });
    }

    // Attach click event listeners to size buttons
    initElements() {
        this.colorButtons = this.querySelectorAll('.product-thumb__item');
        this.sizeButtons = this.querySelectorAll('.quick-add__option:not(.out-of-stock)');
        this.sizeButtonsOutOfStock = this.querySelectorAll('.out-of-stock');
        this.triggerMobile = this.querySelectorAll('.quick-add-mobile')
        this.closeAddToCart = this.querySelectorAll('.quick-add__close')
    }

    attachClickListeners() {
        // Use event delegation if possible, or reattach directly
        this.triggerMobile.forEach(button => {
            button.addEventListener('click', this.openAddToCartMobile.bind(this));
        });
        this.closeAddToCart.forEach(button => {
            button.addEventListener('click', this.closeAddToCartMobile.bind(this));
        });
        this.colorButtons.forEach(button => {
            button.addEventListener('click', this.updateProductInfo.bind(this));
        });
        this.sizeButtons.forEach(button => {
            button.addEventListener('click', (event) => this.addToCart(event));
        });
        this.sizeButtonsOutOfStock.forEach(button => {
            button.addEventListener('click', (event) => this.openModalEmailAlert(event));
        });
    }

    openAddToCartMobile(event) {
        const prevElOpened = document.querySelector('.quick-add-to-cart__inner.active')
        prevElOpened?.classList.remove('active');// Remove active class from previous List.
        event.preventDefault();
        event.target.nextElementSibling.classList.toggle('active');
    }

    closeAddToCartMobile(event) {
        event.preventDefault()// Find the closest parent element with the 'active' class and toggle it
        const activeParent = event.target.closest('.active');
        if (activeParent) {
            activeParent.classList.toggle('active');
        }

    }
    updateProductInfo(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const productHandle = target.getAttribute('data-product');

        // Parse the JSON data from the script tag containing the products information
        const productDataScript = this.querySelector('script[data-product-info]');
        const productsData = JSON.parse(productDataScript.textContent);

        // Find the product information from the JSON data using the product handle
        const productInfo = productsData[productHandle];

        if (productInfo) {
            // Find the closest product-item element to update specific content
            const productItemElement = this.closest('.product-item');

            // Update the product image URLs (parse and update image HTML if necessary)
            const primaryImageElement = productItemElement.querySelector('.product-item__primary-image');
            const secondaryImageElement = productItemElement.querySelector('.product-item__secondary-image');

            // If item_image contains complete HTML, we need to extract and set the `src` and `srcset` attributes.
            if (primaryImageElement && productInfo.item_image) {
                // Extract image URLs and srcsets from the HTML string
                const primaryImageDetails = this.extractImageDetails(productInfo.item_image);
                if (primaryImageDetails) {
                    primaryImageElement.src = primaryImageDetails.src;
                    primaryImageElement.srcset = primaryImageDetails.srcset;
                }
            }

            if (secondaryImageElement && productInfo.item_image) {
                // Assuming secondary image is the second <img> in the HTML string
                const secondaryImageDetails = this.extractImageDetails(productInfo.item_image, true);
                if (secondaryImageDetails) {
                    secondaryImageElement.src = secondaryImageDetails.src;
                    secondaryImageElement.srcset = secondaryImageDetails.srcset;
                }
            }

            // Update the product links
            const productLinks = productItemElement.querySelectorAll('a[href*="/products/"]');
            productLinks.forEach(link => link.href = productInfo.item_url);

            // Update the product price (assuming `item_price` contains ready-to-use HTML)
            const productPriceElement = productItemElement.querySelector('.price');
            if (productPriceElement) productPriceElement.innerHTML = productInfo.item_price;

            // Update the product sizes (if applicable)
            const sizeOptionsContainer = productItemElement.querySelector('.product-item__sizes');
            if (sizeOptionsContainer) sizeOptionsContainer.innerHTML = productInfo.item_sizes;

            // Get all color options and remove the active class from all
            const itemColors = productItemElement.querySelectorAll('.product-thumb__item');
            itemColors.forEach(item => item.classList.remove('current'));
            target.classList.add('current');

            this.dispatchEvent(new CustomEvent('productInfoUpdated', {
                bubbles: true,
                detail: { productHandle }
            }));


            // Log the updated elements for debugging purposes
            console.log('Updated product info for:', productHandle);
        } else {
            console.error('Product not found for handle:', productHandle);
        }
    }

    // Helper function to extract the image details like `src` and `srcset` from the HTML content
    extractImageDetails(imageHtml, isSecondary = false) {
        // Create a temporary element to parse the HTML string and extract image details
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = imageHtml;

        // If isSecondary is true, find the second <img> tag, otherwise find the first <img>
        const imgElements = tempDiv.querySelectorAll('img');
        const imgElement = imgElements.length > 0 ? imgElements[isSecondary ? 1 : 0] : null;

        if (imgElement) {
            return {
                src: imgElement.src, // Extract the `src` attribute
                srcset: imgElement.getAttribute('srcset') || '' // Extract the `srcset` attribute
            };
        }
        return null;
    }


    // Method to handle add-to-cart functionality
    async addToCart(event) {
        event.preventDefault();
        const variantId = event.target.getAttribute('variant-id');
        const form = this.querySelector('form');
        const productName = this.querySelector('input[name="product"]').getAttribute('data-product');

        addToCart({ 'id': variantId, 'quantity': 1 }, true, true);
    }

    openModalEmailAlert(event) {
        event.preventDefault();
        const productHandle = event.target.getAttribute('product-handle');
        const variantId = event.target.getAttribute('variant-id');

        // Construct the URL with variant ID and view as query parameters
        const modalUrl = `/products/${productHandle}?variant=${variantId}&view=modal-email-alert`;

        this.getItemHtml(productHandle, variantId)
            .then((html) => {
                const modalContent = document.querySelector('#product-alert-popup .modal__alert-content');
                const productContent = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-alert');

                modalContent.innerHTML = productContent.innerHTML;
            })
            .catch((err) => {
                console.error('Failed to fetch product HTML:', err);
            });
    }


    getItemHtml(handle, variant, view = 'modal-email-alert') {
        if (!handle) {
            return Promise.reject('No handle provided');
        }

        const base = Shopify.routes.root || '';
        const params = `products/${handle}?&view=${view}`;
        let variantString = '';
        if (variant) {
            variantString = `&variant=${variant}`;
        }
        const url = `${base}${params}${variantString}`;

        return fetch(url)
            .then(function (response) {
                return response.text();
            })
            .catch(function (err) {
                console.error('Something went wrong.', err);
            });
    }



    // Toggle loading and success/error states
    toggleLoadingState(isLoading) {
        if (isLoading) {
            this.classList.add('loading');
        } else {
            this.classList.remove('loading');
        }
    }

    // Handle success state
    handleSuccess() {
        this.toggleLoadingState(false);
        this.classList.add('added-successfully');
        setTimeout(() => {
            this.classList.remove('added-successfully');
        }, 1000);
    }

    // Handle error state
    handleError() {
        this.toggleLoadingState(false);
        this.classList.add('error');
    }
}

// Define the custom element
window.customElements.define("quick-add-to-cart", QuickAddToCart);
